export default __webpack_public_path__ + "assets/5ca0c16052477a444fc655fee01245c5-postcard.png";